export default {"src":"/_next/static/media/calmini.584a2907.svg","height":125,"width":85,"blurWidth":0,"blurHeight":0};